import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { TopBar } from "../../../../../widgets";
import { Button, Divider, Flex } from "antd";
import { deepLinkBridgeElseNewTab, moneyStringFormatByNumber } from "../../../../../utils";
import { ReactComponent as Close } from "../../../../../assets/images/icon/close.svg"
import dayjs, { Dayjs } from "dayjs";
import { setUrl } from "../../../../../service";

const ProgramBookingPayInfo = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { programBookingId, price, orderId, orderName, couponId, issuedYogaCouponId, pointValue, selectedConselingBranch, programBookingTicketWebResponseList, programBookingStatus, paymentDeadline, receiptUrl } = location.state;

    if (programBookingId == null || price == null || orderId == null || orderName == null || couponId == null || issuedYogaCouponId == null || pointValue == null || selectedConselingBranch == null || programBookingTicketWebResponseList == null || programBookingStatus == null) return <Navigate to="/my" />;

    const checkPaymentDeadlineIsToday = (paymentDeadline: Dayjs) => {
        const today = dayjs().format('YYYY.MM.DD')
        const tomorrow = dayjs().add(1, 'day').format('YYYY.MM.DD')
        const targetDate = paymentDeadline.format('YYYY.MM.DD')
        if (today === targetDate) {
            return '오늘 ' + paymentDeadline.format('HH:mm')
        } else if (tomorrow === targetDate) {
            return '내일 ' + paymentDeadline.format('HH:mm')
        } else {
            return paymentDeadline.format('YYYY.MM.DD HH:mm')
        }
    }
    const clickPaymentButton = () => {
        const checkoutState = {
            programBookingId: programBookingId,
            price: price,
            orderId: orderId,
            orderName: orderName,
            couponId: couponId,
            issuedYogaCouponId: issuedYogaCouponId,
            pointValue: pointValue,
            selectedConselingBranch: selectedConselingBranch,
        }
        setUrl(location.pathname)
        navigate(`/program-booking-checkout/${programBookingId}`, { state: checkoutState })
    }

    return <>
        <TopBar title="결제 금액" type='closeIcon' rightIcon={false} position='fixed' thema='dark' />
        <div style={{ margin: '32px 20px' }}>
            {programBookingTicketWebResponseList
                .filter((bookingTicket: IProgramBookingTicketWebResponse) => bookingTicket.programBookingTicketCount > 0)
                .map((bookingTicket: IProgramBookingTicketWebResponse, idx: number) => <Flex key={idx} justify="space-between" style={{ marginTop: 16 }}>
                    <div className="body/b2">{bookingTicket.programTicketName}</div>
                    <div style={{ textAlign: 'right' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className="body/b2">{moneyStringFormatByNumber(bookingTicket.programTicketPayAmount)} 원 </div>
                            <div style={{ width: 24, height: 22 }}>
                                <Close style={{ padding: '3.5px 4.5px' }} width={15} height={15} stroke="var(--secondarys500)" />
                            </div>
                            <div className="body/b2"> {bookingTicket.programBookingTicketCount}</div>
                        </div>
                        <div className="sub-title/st2" style={{ marginTop: 4 }}>{moneyStringFormatByNumber(bookingTicket.programBookingTicketPrice)} 원</div>
                    </div>
                </Flex>)}

            <Divider style={{ borderBlockStart: '1px solid var(--secondarys500)', marginBlock: 20 }} />
            <Flex justify="space-between" style={{ marginBlock: 16 }}>
                <div className="sub-title/st2">총 결제금액</div>
                <div style={{ textAlign: 'right' }}>
                    <div className="sub-title/st3">{moneyStringFormatByNumber(price)} 원</div>
                </div>
            </Flex>
            {programBookingStatus === '결제 요청' &&
                <div className="body/b1 secondary/s500" style={{ textAlign: 'right' }}>
                    ※ 예약 확정 후 결제가 진행됩니다.
                </div>}
        </div>
        <div style={{ position: 'absolute', bottom: 0, width: '100%', maxWidth: '480px' }}>
            {programBookingStatus === '결제 요청'
                ? <>
                    <div className="body/b2" style={{ textAlign: 'center' }}><span className="error/e700">{checkPaymentDeadlineIsToday(dayjs(paymentDeadline))}</span> 까지 미결제 시 예약 자동 취소</div>
                    <div style={{ padding: '20px 20px 40px 20px' }}>
                        <Button className="sub-title/st3 base/white" block color="default" variant="solid" style={{ width: '100%', height: '50px' }} onClick={() => clickPaymentButton()}>결제하기</Button>
                    </div>
                </>
                : programBookingStatus === '예약 확정' && receiptUrl &&
                <div style={{ padding: '20px 20px 40px 20px' }}>
                    <Button className="sub-title/st2 secondary/s600" block color="default" variant="outlined" style={{ width: '100%', height: '50px', border: '1px solid var(--secondarys400)', borderRadius: 4 }} onClick={() => deepLinkBridgeElseNewTab(receiptUrl)}>영수증 보기</Button>
                </div>
            }

        </div>
    </>
}
export default ProgramBookingPayInfo